import { useEffect, useState } from "react";
import NotificationItem from "defaultComponents/Items/NotificationItem";
import { Card, Grid } from '@mui/material';
import VuiTypography from 'components/VuiTypography';
import * as S from './style'
import { getNotifications, deleteSelfNotification } from 'utils/requests/other';
import moment from 'moment-timezone';
import 'moment/locale/pt-br';
import { useNavigate } from "react-router-dom";
import { getWithdrawPlea } from "utils/requests/withdraw";

const Notifications = () => {
  const navigate = useNavigate();

  const [notificationsLog, setNotificationsLog] = useState()

  const fetchData = async () => {
    await getNotifications().then(res => {
      if (!res?.message) {
        setNotificationsLog(res);
      };
    });
  };

  const handleDelete = async (id, navigateTo) => {
    try {
      await deleteSelfNotification(id).then((res) => {
        if (res?.id && navigateTo) {
          navigate(navigateTo);
        }
      });
    } catch {
      return
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleNavigation = async (notification) => {
    let withdrawPlea = null;

    if (!notification?.entityType) return;
    
    if (notification.entityType === 'WithdrawPlea') {
      withdrawPlea = await getWithdrawPlea(notification?.entityId);
      if (!(withdrawPlea?.influencerRelated?.username)) return;
    }
    if (notification?.entityType === 'Versions') {
      handleDelete(notification?.id, '/versions');
      return;
    }
    if (notification?.type === 'MENTION') {
      if(notification?.entityType === 'PipelineCards') {
      const cardId = notification?.entityId;
      const kanbanUrl = cardId
        ? `/marketing/pipeline/kanban?cardId=${cardId}`
        : '/marketing/pipeline/kanban';
        handleDelete(notification?.id, kanbanUrl);
        return;
      }
      if (notification?.entityType === 'Project') {
        const cardId = notification?.entityId;
        const kanbanUrl = cardId
          ? `/comercial/pipeline/todos?cardId=${cardId}`
          : '/comercial/pipeline/todos';
 
        handleDelete(notification?.id, kanbanUrl);
        return;
      }
    }
    const entityTypeToEndpoint = {
      'PipelineCards': '/marketing/pipeline',
      'Project': '/marketing/projetos',
      'WithdrawPlea': `/influencers/${withdrawPlea?.influencerRelated?.username}/financeiro/saque`,
      'Financial': '/financeiro/contas',
    };
//
    return navigate(entityTypeToEndpoint[notification.entityType])|| undefined;
  };

  const splitStringByAsterisks = (text) => {
    const pattern = /(\*+)([^*]+)\1/;

    const isValid = pattern.test(text);

    if (!isValid) {
      return ['', text];
    };

    const match = text.match(pattern);
    const wrappedText = match[2];
    const afterAsterisks = text.slice(match.index + match[0].length);

    return [wrappedText, afterAsterisks.trim()];
  };

  return (
    <Card sx={{ maxHeight: "335px", backdropFilter: "blur(120px)" }}>
      <Grid display='flex' flexDirection='column'>
        <VuiTypography variant='lg' color='white' fontWeight='bold' mb='4px'>
          Notificações
        </VuiTypography>
        <S.NotificationGrid container>
          {(notificationsLog && notificationsLog[1] === 0) &&
            <p className="emptyMessage">Não há notificações</p>
          }
          {notificationsLog && notificationsLog[0]?.map((notification) => (
            <NotificationItem
              key={notification?.id}
              image={notification?.notificationBackground}
              title={splitStringByAsterisks(notification?.action)}
              date={moment().to(moment(notification?.createdAt).tz('America/Maceio').format())}
              onClick={() => handleNavigation(notification)}
            />
          ))
          }
        </S.NotificationGrid>
      </Grid>
    </Card>
  )
}

export default Notifications